class VariantSwatches extends HTMLElement {
  constructor() {
    super();
    this.productMedia = this.getProductMedia();
    this.handleSwatchClick();
  }

  getProductMedia() {
    try {
      const productMedia = this.querySelector('script[type="application/json"]').textContent;
      return JSON.parse(productMedia);
    } catch (error) {
      console.error('Error parsing product media', error);
      return [];
    }
  }

  handleSwatchClick() {
    this.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.addEventListener('change', (event) => {
        const mediaId = event.target.dataset.mediaId;
        const media = this.productMedia.find((media) => media.id == mediaId);
        
        if (media && media.src) {
          this.replaceMedia(media.src);
        } else {
          console.warn('Media not found for ID:', mediaId);
        }
      });
    });
  }

  replaceMedia(media) {
    if (!media) return;

    // Buscar el .kc-product-card más cercano (solo afecta a este card)
    const productCardContainer = this.closest('.kc-product-card');
    
    if (!productCardContainer) {
      console.warn('No .kc-product-card found for this swatch');
      return;
    }

    const imageWrapper = productCardContainer.querySelector('.kc-product-card__image');
    
    if (!imageWrapper) {
      console.warn('No .kc-product-card__image found');
      return;
    }

    const image = imageWrapper.querySelector('img');
    
    if (!image) {
      console.warn('No img found in .kc-product-card__image');
      return;
    }

    // Remover srcset para forzar el uso de src
    image.removeAttribute('srcset');

    // Crear overlay de carga
    const loadingOverlay = document.createElement('div');
    loadingOverlay.className = 'loading-overlay';
    loadingOverlay.innerHTML = `
      <div class="loading-spinner"></div>
    `;
    
    // Añadir estilos inline si no existen
    if (!document.querySelector('#variant-swatches-loading-styles')) {
      const style = document.createElement('style');
      style.id = 'variant-swatches-loading-styles';
      style.textContent = `
        .loading-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(255, 255, 255, 0.8);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10;
        }
        .loading-spinner {
          width: 40px;
          height: 40px;
          border: 3px solid #f3f3f3;
          border-top: 3px solid #333;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `;
      document.head.appendChild(style);
    }
    
    imageWrapper.appendChild(loadingOverlay);

    // Precargar la nueva imagen
    const newImage = new Image();
    newImage.onload = () => {
      image.src = media;
      loadingOverlay.remove();
    };
    newImage.onerror = () => {
      console.error('Error loading image:', media);
      loadingOverlay.remove();
    };
    newImage.src = media;
  }
}

if (!customElements.get('variant-swatches')) {
  customElements.define('variant-swatches', VariantSwatches);
}